class QueryParamStringStrategy {
    build = (queryParam={}) => {
        // if a queryParam object is provided,
        // then add the params to the queryParamString
        let queryParamString = "";
        const queryParamKeyList = Object.keys(queryParam);
        if (queryParamKeyList.length > 0) {
            let queryParamKeyValueList = [];
            queryParamKeyList.forEach((param) => {
                queryParamKeyValueList.push(`${param}=${queryParam[param]}`)
            })
            queryParamString = `?${queryParamKeyValueList.join("&")}`;
        }
        return queryParamString;
    }
}

export default QueryParamStringStrategy;